
define('text!templates/modules/profile/edit/custom-message-edit-form.html',[],function () { return '<div class="title-input"></div>\n<div class="default-welcome-message-input"></div>\n<div class="message-input"></div>\n';});

